/**
 * The directory's data entry. Screens outside the feature still read the expert search through
 * the compatibility path in `services/`, which re-exports all of this.
 */
export * from './algoliaExperts';
